import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardResolver } from './dashboard.resolver';
import { LandingModule } from './landing/landing.module';
import { DashboardService } from './dashboard.service';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [DashboardComponent],
  providers: [DashboardService, DashboardResolver],
  imports: [CommonModule, SharedModule, DashboardRoutingModule, LandingModule],
})
export class DashboardModule {}
